<template>
  <div>
    <!--  Bộ lọc  -->
    <div>
      <el-row type="flex">
        <el-col :span="20">
          <el-row type="flex" :gutter="4">
            <el-col :span="6">
              <el-input
                  :clearable="true"
                  style="width: 100%"
                  placeholder="Nhập tiêu đề hoặc mã phiếu"
                  v-model="dataFilter.name"
                  @keyup.enter.native="handleFilterData"
                  @clear="handleFilterData"
              >
                <template #append>
                  <el-button
                      icon="el-icon-search"
                      @click="handleFilterData"
                  ></el-button>
                </template>
              </el-input>
            </el-col>

            <el-col :span="6">
              <el-date-picker
                  style="width: 100%"
                  v-model="dataFilter.dateRange"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Ngày bắt đầu"
                  end-placeholder="Ngày kết thúc"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  @change="handleFilterData"
              >
              </el-date-picker>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="4">
          <el-row type="flex" :justify="'end'">
            <el-col :span="11">
              <el-button style="width: 100%" type="success" @click="handleOpenCreateDialog">
                <i class="el-icon-plus"/>
                Thêm mới
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div style="margin: 20px 0">
      <el-table
          ref="tableSurveyForm"
          element-loading-spinner="el-icon-loading"
          :data="dataTableSurveyForm"
          border
          :max-height="$tableMaxHeight"
          :header-cell-style="headerCellStyle"
          :element-loading-text="$tableLoading"
          @selection-change="handleSelectionChange"
          element-loading-background="rgba(255,255,255, 0)"
          v-loading="isLoading"
      >
        <el-table-column
            type="selection"
            width="50"
            align="center"
        />

        <el-table-column
            type="index"
            label="STT"
            width="50"
            align="center"
        />

        <el-table-column
            label="Ngày tạo"
            width="160"
            align="center"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.createdDate | formatDateTime }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Mã phiếu"
            width="180"
            align="center"
        >
          <template v-slot:default="scope">
            <span style="text-transform: uppercase">{{ scope.row.codeForm }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Tiêu đề"
            width="380"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Mô tả"
        >
          <template v-slot:default="scope">
            <span style="white-space: pre-line">{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Tác vụ"
            width="240"
            align="center"
        >
          <template v-slot:default="scope">
            <div>
              <el-button @click="handleDetailForm(scope.row.idForm)" size="small" type="primary">
                Chi tiết
              </el-button>

              <el-button @click="handleUpdateForm(scope.row.idForm)" size="small" type="success">
                Sửa
              </el-button>

              <el-button @click="deleteForm([scope.row.idForm])" size="small" type="danger">
                Xoá
              </el-button>
            </div>
          </template>
        </el-table-column>

        <template #empty>
          <div style="text-align: center; font-size: 16px; color: #43a0ff;">
            <i class="el-icon-warning"></i>
            <span> Không có dữ liệu! </span>
          </div>
        </template>
      </el-table>
    </div>

    <!--  Tác vụ  -->
    <div class="footer_task">
      <el-row type="flex">
        <el-col :span="16">
          <div class="container_nav_page">
            <el-pagination
                style=" margin-right: 200px"
                background
                layout="prev, pager, next, sizes"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page.sync="dataFilter.page"
                :page-sizes="listSizePage"
                :total="totalRecords">
            </el-pagination>
          </div>
        </el-col>

        <el-col :span="8">
          <el-row type="flex" :justify="'end'">
            <el-col :span="5">
              <el-menu
                  class="menu_task_form"
                  background-color="#67C23A"
                  text-color="#FFF
"
                  active-text-color="#FFF"
                  mode="horizontal"
                  :unique-opened="true"
                  menu-trigger="hover"
              >
                <el-submenu index="1" popper-class="sub_menu">
                  <template #title>
                    Tác vụ
                  </template>
                  <el-menu-item index="2" @click="handleRemoveMultipleForm" class="submenu-left">
                    <template #title>Xoá phiếu khảo sát</template>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!--  Dialog  -->
    <CreateSurveyFormSystem
        :is-open="isOpenDialog.createSurveyForm"
        @closeDialog="handleCloseCreateDialog"
    />

    <UpdateSurveyFormSystem
        :is-open="isOpenDialog.updateSurveyForm"
        @closeDialog="handleCloseUpdateDialog"
        ref="updateSurveyForm"
    />

    <DetailSurveyFormSystem
        :is-open="isOpenDialog.detailSurveyForm"
        @closeDialog="handleCloseDetailDialog"
        ref="detailSurveyForm"
    />
  </div>
</template>

<script>
import CreateSurveyFormSystem from "@/views/master/systemconfig/SurveyForm/dialog/CreateSurveyFormSystem.vue";
import UpdateSurveyFormSystem from "@/views/master/systemconfig/SurveyForm/dialog/UpdateSurveyFormSystem.vue";
import DetailSurveyFormSystem from "@/views/master/systemconfig/SurveyForm/dialog/DetailSurveyFormSystem.vue";
import FormSystemService from "@/services/AdminService/FormSystemService";

const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}
export default {
  components: {
    DetailSurveyFormSystem,
    UpdateSurveyFormSystem,
    CreateSurveyFormSystem
  },
  data() {
    return {
      isOpenDialog: {
        createSurveyForm: false,
        updateSurveyForm: false,
        detailSurveyForm: false,
      },
      dataTableSurveyForm: [],
      totalRecords: 0,
      dataFilter: {
        name: "",
        dateRange: null,
        page: 1,
        limit: 30,
      },
      isLoading: false,
      optionsTypeApply: [
        {
          value: "plus",
          label: "Trường"
        },
        {
          value: "teacher",
          label: "Lớp"
        }
      ],
      listSizePage: [30, 40, 50, 100, 200, 500],
    }
  },
  created() {
    this.fetchDataTableSurveyForm();
  },
  methods: {
    headerCellStyle,
    fetchDataTableSurveyForm() {
      const data = {
        typeform: "",
        nameFormOrId: this.checkSearchNameOrId(),
        idClass: "",
        fistTimeCreate: this.dataFilter.dateRange ? this.dataFilter.dateRange[0] : "",
        lastTimeCreate: this.dataFilter.dateRange ? this.dataFilter.dateRange[1] : "",
        apply: "",
        fistTimeApply: "",
        lastTimeApply: "",
        pageNumber: this.dataFilter.page,
        maxPageItem: this.dataFilter.limit,
      }

      this.isLoading = true;
      FormSystemService.filterData(data)
          .then((res) => {
            const data = res.data.data;
            this.dataTableSurveyForm = data.responseList;
            this.totalRecords = data.totalRecords;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    handleOpenCreateDialog() {
      this.isOpenDialog.createSurveyForm = true;
    },

    handleCloseCreateDialog() {
      this.isOpenDialog.createSurveyForm = false;
      this.fetchDataTableSurveyForm();
    },

    handleCloseUpdateDialog() {
      this.isOpenDialog.updateSurveyForm = false;
      this.fetchDataTableSurveyForm();
    },

    handleCloseDetailDialog() {
      this.isOpenDialog.detailSurveyForm = false;
      this.fetchDataTableSurveyForm();
    },


    handleFilterData() {
      this.dataFilter.page = 1;
      this.fetchDataTableSurveyForm();
    },

    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.fetchDataTableSurveyForm();
    },

    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.fetchDataTableSurveyForm();
    },

    handleRemoveMultipleForm() {
      const dataMultiple = this.selectionMultiple;

      if (dataMultiple.length > 0) {
        const ids = [];

        dataMultiple.map((item) => {
          ids.push(item.idForm);
        })
        this.deleteForm(ids);
      } else {
        this.$message({
          type: "error",
          message: "Bạn chưa chọn phiếu khảo sát nào!"
        })
      }
    },

    handleDetailForm(id) {
      this.isOpenDialog.detailSurveyForm = true;
      this.$refs.detailSurveyForm.handleInitialData(id);
    },

    handleUpdateForm(id) {
      this.isOpenDialog.updateSurveyForm = true;
      this.$refs.updateSurveyForm.handleInitialData(id)
    },

    deleteForm(idList) {
      this.$confirm("Bạn có chắc chắn muốn xóa phiếu khảo sát đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        FormSystemService.deleteFormById(idList).then((res) => {
          this.$message({
            type: "success",
            message: res.data.message
          })

          this.handleFilterData();
        }).catch((err) => {
          this.$message({
            type: "error",
            message: err.data.message
          })
        })
      });
    },

    handleSelectionChange(value) {
      this.selectionMultiple = value;
    },

    checkSearchNameOrId() {
      const regexId = /^FORM_(\d+)(?:_\d{8})?$/;
      const value = this.dataFilter.name;

      if (regexId.test(value)) {
        const id = value.match(regexId);
        return id[1];
      } else {
        return value;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container_nav_page {
  /deep/ .el-pagination {
    display: flex;
    justify-content: end;
  }
}

.footer_task {
  margin-top: 20px;
}

.menu_task_form {
  background-color: transparent !important;
  display: flex;
  justify-content: end;
  align-content: center;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 36px;
  line-height: 35px;
  border-bottom: 0 solid transparent;
  border-radius: 4px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}
</style>